import { createFileRoute, redirect } from '@tanstack/react-router';

/** Caminho antigo: a tela da Empresa mora em /configuracoes/empresa (o search (?secao=) vai junto). */
export const Route = createFileRoute('/_app/cadastros/empresa')({
  beforeLoad: () => {
    throw redirect({ to: '/configuracoes/empresa', search: true, replace: true });
  },
});
